import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 bg-accent-navy text-white" data-id="element-25">
      <div className="max-w-4xl mx-auto text-center" data-id="element-26">
        <h3 className="font-bebas text-2xl md:text-3xl uppercase mb-4" data-id="element-27">
          COMUNITĂȚI ONLINE — Tot business-ul tău online într-un singur sistem
        </h3>

        <p className="font-jakarta text-body md:text-lg mb-6" data-id="element-28">
          Adrian Puiu | Academia Experților | Comunități Online
        </p>

        <p className="font-jakarta text-sm text-white/70 mb-4" data-id="element-29">
          © 2025. Toate drepturile rezervate.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm font-jakarta mb-4" data-id="element-30">
          <a href="#" className="text-white/80 hover:text-white transition-colors" data-id="element-31">
            Termeni și condiții
          </a>
          <span className="text-white/50" data-id="element-32">—</span>
          <a href="#" className="text-white/80 hover:text-white transition-colors" data-id="element-33">
            Politica de confidențialitate
          </a>
          <span className="text-white/50" data-id="element-34">—</span>
          <a href="#" className="text-white/80 hover:text-white transition-colors" data-id="element-35">
            Contact
          </a>
        </div>

        <a href="https://www.comunitati.online" target="_blank" rel="noopener noreferrer" className="font-jakarta text-sm text-accent-gold hover:text-accent-gold/80 transition-colors" data-id="element-36">
          www.comunitati.online
        </a>
      </div>
    </footer>;
}